import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loggedIn, setLoggedIn } from "../auth/authReducer";
import { useLoginMutation } from "../auth/authApiSlice";
import { useSelector } from "react-redux";
import { useUserActionsMutation } from "../api/userActionsApiSlice";
import { setPermittedActions } from "../ui/permittedActionsReducer";
import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
} from "@fortawesome/free-solid-svg-icons";

import "../../assets/css/login-page.scss";
import voltupLogo from "../../assets/images/voltup-logo.png";
import { selectCurrentToken } from "../auth/authReducer";
import Loading from "./Loading";

const LoginCard = (props) => {
  const emailRef = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [login, { isLoading }] = useLoginMutation();
  const [userActions] = useUserActionsMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(selectCurrentToken);

  useEffect(() => {
    if (token?.access_token !== null) {
      navigate("/dashboard");
    }
    emailRef.current.focus();
  }, []);

  useEffect(() => {
    setErrorMessage("");
    setDisableSubmit(
      email.toString().trim() === "" || password.toString().trim() === ""
    );
  }, [email, password]);

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordInput = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (isLoggedIn) {
      setPermissions();
    }
  }, [isLoggedIn]);

  if (isLoading) {
    return <Loading />;
  }

  const setPermissions = async () => {
    try {
      const actionsData = await userActions({}).unwrap();
      dispatch(
        setPermittedActions({
          permittedActions: actionsData.data.permitted_actions,
        })
      );
      navigate("/dashboard");
    } catch (error) {
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const userData = await login({
        login: email.toLowerCase(),
        password: password,
      }).unwrap();
      const { user, token } = userData.data;
      setIsLoggedIn(true);
      dispatch(setLoggedIn(loggedIn(user, token)));
      setEmail("");
      setPassword("");
    } catch (err) {
      if (err.data){
       setErrorMessage(err.data.message);
      } else{
       setErrorMessage("Something went wrong");
      }
    }
  };

  const handleForgotPassword = () => {
    props.onForgotPasswordClick();
  };

  return (
    <div>
      <form onSubmit={handleLogin}>
        <Card className="login-card">
          <Card.Img variant="top" src={voltupLogo} />
          <Card.Body>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <div className="text-danger">{errorMessage}</div>
                <Row className="mb-4">
                  <Col>
                    <div className="input-icon-wrapper">
                      <FontAwesomeIcon className="icon-left" icon={faEnvelope} />
                      <input
                        type="text"
                        ref={emailRef}
                        value={email}
                        onChange={handleEmailInput}
                        placeholder="Email/Username"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <div className="input-icon-wrapper">
                      <FontAwesomeIcon className="icon-left" icon={faLock} />
                      <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={handlePasswordInput}
                        placeholder="Password"
                      />
                      <FontAwesomeIcon
                        className="icon-right"
                        icon={showPassword ? faEyeSlash : faEye}
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <button type="button" className="fw-normal btn" onClick={handleForgotPassword}>
                      Register
                    </button>
                  </Col>
                  <Col>
                    <button type="submit" disabled={disableSubmit} className="fw-normal btn">
                      Login
                    </button>
                  </Col>
                </Row>
                <div className="text-center frgtPwd">
                  <em>
                    <a onClick={handleForgotPassword}>Forgot Password ?</a>
                  </em>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </form>
    </div>
  );
};

export default LoginCard;
